import React, { useState, useEffect } from 'react';
import { formatRelativeTime } from './utils';

function TaskBar({ task, onDragStart, onDragEnd, onClick, isDragging, isOngoingTask }) {
  const [, setCurrentTime] = useState(Date.now());

  useEffect(() => {
    // Update every 10 seconds to refresh timestamp display
    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`task-bar ${isDragging ? 'dragging' : ''} ${isOngoingTask ? 'ongoing-task' : ''}`}
      draggable
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onClick={onClick}
    >
      <div className="task-content">
        <div className="task-text">{task.text}</div>
        {task.status && <div className="task-status">{task.status}</div>}
      </div>
      {task.lastWorkedOn && !isOngoingTask && (
        <div className="task-timestamp">
          {formatRelativeTime(task.lastWorkedOn)}
        </div>
      )}
    </div>
  );
}

export default TaskBar;

